import React, { Props, Component, Fragment } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import ImagesUpload from '../Components/ImagesUpload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
 
import MessagesPanel from '../Components/MessagesPanel';
import BookingsView from '../Components/BookingsView';

import Paper from '@material-ui/core/Paper';

import Drawer from './Common/Drawer'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';


import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { compose } from 'redux';
import { connect } from 'react-redux';

import AppBar from './Common/MainAppBar';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import Label from '@material-ui/icons/Label';

import { validateUser, storeAuthToken, fetchUser, storeUser } from '../Actions/AuthActions';
import { Redirect } from 'react-router-dom'

import logo from '../Img/logo.png'
import Profile from '../Img/profile.png'
import Loader from './Common/Loader';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Divider } from '@material-ui/core';
// import ReactRichEditor from 'react-rich-text-editor';


import { UpdateMessage } from '../Actions/MessagesActions';




const drawerWidth = 240;

const styles = theme => ({

  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },

  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },

  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },

  fab: {
    margin: theme.spacing.unit,
  },

  extendedIcon: {
    marginRight: theme.spacing.unit,
  },

  wrap: {
    width: 480,
    margin: 'auto',
    marginTop: 100,

  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,

  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '98%'
  },

  button: {
    margin: theme.spacing.unit,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },

  logoWrap: {
    textAlign: 'center',
  },
  toolbar: theme.mixins.toolbar,
});




const mapStateToProps = (state) => {
  return {
    loading: state.Common.loading,
    loggedIn: state.Auth.loggedIn,
    activeDeal:state.Deals.activeDeal
  }
}


const mapDispatchToProps = dispatch => ({

  UpdateMessage:(data)=>dispatch(UpdateMessage(data)),
  
});


const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#666ad1',
      main: '#303f9f',
      dark: '#001970',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff5c8d',
      main: '#d81b60',
      dark: '#a00037',
      contrastText: '#000',
    },

    third: {
      light: '#6d6d6d',
      main: '#424242',
      dark: '#1b1b1b',
      contrastText: '#fff',
    },
  },
});

class Tours extends Component {

  constructor(props) {
    super(props);

   

    this.state = {      
      id:0,
      title:"",
      description:"",      
      image_name:null,
      uploadImage:null,
    };


   
  }

  

  componentDidMount() {
    document.body.style.background = "#eee";

  }

  handleChange = ( event, name ) => {
    this.setState({
      [name]: event.target.value,
    });

  };

  uploadImage = (e) => {

    if (e.target.files[0] != null) {

      this.setState({
        uploadImage: e.target.files[0],
      });      
    }

  }
  

  onSave = () =>{
    this.props.UpdateMessage(this.state);
    return <Redirect to="/Admin" />;
  }

  render() {

    const { classes } = this.props;

    


    return <Fragment>

      <AppBar title="Dashboard"></AppBar>

      <Drawer></Drawer>

      <div style={{ width: 'auto', marginLeft: drawerWidth + 0, paddingTop: 35, height: 250 }}><div>

      <Table>

          <TableBody> 
            <TableRow>
                  <TableCell style={{backgroundColor:'white', width:500,fontWeight:600, fontSize:15}}>New Message</TableCell>
                  <TableCell style={{backgroundColor:'white', width:0,fontWeight:600, fontSize:15}}>
                    <Button style={{ width:150, marginLeft: 350 , background:"#f7a414" }} variant="contained" color="primary" size="small" component={Link} to="/Admin" className={classes.button}>Back</Button>
                  </TableCell> 

                         

            </TableRow>

          </TableBody>
        </Table>

        <Table>
          <TableBody>
            <TableRow>

              <TableCell style={{ backgroundColor: '#f2f2f2', width: 700, fontWeight: 500, paddingTop: 25 }} component="th">

                <Paper className={classes.root} elevation={1} style={{ marginBottom: 0 }}>                     

                
                <table width="100%" >
                    <tr>
                        <td width="50%" >
                        <div style={{marginTop:25}}>
                            <FormControl style={{width:'100%'}}>
                                <TextField
                                    name="deal_name"
                                    id="deal_name"
                                    value={this.state.title}
                                    onChange={(e)=>{this.handleChange(e,'title')}}
                                    variant="outlined"
                                    label="Subject"
                                    
                                />
                            </FormControl>
                          </div>
                          
                          <div style={{marginTop:25}}>
                          <FormControl style={{width:'100%'}}>
                                 <TextField
                                    
                                    multiline
                                    rows="4"
                                    name="deal_name"
                                    id="deal_name"
                                    value={this.state.description}
                                    onChange={(e)=>{this.handleChange(e,'description')}}
                                    variant="outlined"
                                    label="Message"
                                /> 
                      
                            </FormControl>
                            {/* <ReactRichEditor height={200} />  */}
                          </div>                          
                          <div style={{marginTop:25}}>
                          <input
                              accept="image/*"
                              style={{ display: "none" }}
                              id="file-work-logo"
                              type="file"
                              onChange={this.uploadImage}
                            />
                            <label htmlFor="file-work-logo">
                              <Button component="span" variant="contained" color="default" className={classes.button}>
                                Upload Image &nbsp;
                                                <CloudUploadIcon className={classes.rightIcon} />
                              </Button>
                            </label>
                          </div>   
                        </td>
                        <td width="50%" style={{ padding: 15, verticalAlign: 'top'}} >
                        { this.state.image_name !== "" ? (<img src={this.state.image_name} width="100%" height="auto" />):null}
                        </td>
                    </tr>

                    <tr>
                    {/* <div className="App">
                <h2>Using CKEditor 5 build in React</h2>
                <CKEditor
                    editor={ ClassicEditor }
                    data="<p>Hello from CKEditor 5!</p>"
                    onInit={ editor => {
                        // You can store the "editor" and use when it is needed.
                        console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                        const data = editor.getData();
                        console.log( { event, editor, data } );
                    } }
                    onBlur={ ( event, editor ) => {
                        console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        console.log( 'Focus.', editor );
                    } }
                />
            </div> */}


                    </tr>


                </table>         
 
                
         
         

       
<TableRow>

<br /> 

<td>
  <div style={{ float:'right', align:'right'}}   >
 &nbsp;&nbsp;&nbsp; <Button onClick={this.onSave} style={{background:"#f7a414",  marginLeft: '445px'}} size="small" variant="contained" color="primary" className={classes.button}  >Save</Button>
  </div>
</td>
{/* <Button onClick={this.onSave} style={{background:"#f7a414", marginLeft: 0 }} variant="contained" color="primary" className={classes.button}  >Save</Button> */}

</TableRow>

<br /> <br /> 



                </Paper>

              </TableCell>
            </TableRow>
          </TableBody>
          <br />
        </Table>
        
      </div>
      </div>

    </Fragment>
  }
}

Tours.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(Tours);